import React from "react"
import { type RouteObject } from "react-router-dom"

import { RoutesPaths } from "../../../constants/routes.ts"
import { lazyPage } from "../../InitComponent/router/lazyPage.tsx"

// Each Guide screen is its own file: the tour previews render the real Lead
// and Project sections, which pull in the rich text editor and the
// milestone/finance tables, none of which the first screen needs.
const GuideAcademyModulePage = lazyPage(() =>
  import("../GuideAcademyModulePage.tsx").then((m) => ({
    default: m.GuideAcademyModulePage
  }))
)
const GuideHomePage = lazyPage(() =>
  import("../GuideHomePage.tsx").then((m) => ({ default: m.GuideHomePage }))
)
const GuideLessonPage = lazyPage(() =>
  import("../GuideLessonPage.tsx").then((m) => ({ default: m.GuideLessonPage }))
)
const GuideProductStoryPage = lazyPage(() =>
  import("../GuideProductStoryPage.tsx").then((m) => ({
    default: m.GuideProductStoryPage
  }))
)
const GuideQAPage = lazyPage(() =>
  import("../GuideQAPage.tsx").then((m) => ({ default: m.GuideQAPage }))
)
const LearnEZBuildPage = lazyPage(() =>
  import("../LearnEZBuildPage.tsx").then((m) => ({
    default: m.LearnEZBuildPage
  }))
)
const GuideTourPreviewLeadPage = lazyPage(() =>
  import("../tour-preview/GuideTourPreviewLeadPage.tsx").then((m) => ({
    default: m.GuideTourPreviewLeadPage
  }))
)
const GuideTourPreviewProjectPage = lazyPage(() =>
  import("../tour-preview/GuideTourPreviewProjectPage.tsx").then((m) => ({
    default: m.GuideTourPreviewProjectPage
  }))
)

// The Guide is available to every authenticated user regardless of the
// backend's per-tenant permission templates (see sidebar-config.tsx), so
// none of these routes sit behind a PermissionGate. The tour-preview routes
// are no exception — they're static and read no real data, so there's
// nothing on them a PermissionGate would meaningfully protect.
export const guideRoutes: RouteObject[] = [
  {
    path: RoutesPaths.guide.home,
    element: <GuideHomePage />
  },
  {
    path: RoutesPaths.guide.story,
    element: <GuideProductStoryPage />
  },
  {
    path: RoutesPaths.guide.academy,
    element: <LearnEZBuildPage />
  },
  {
    path: RoutesPaths.guide.module(":moduleSlug"),
    element: <GuideAcademyModulePage />
  },
  {
    path: RoutesPaths.guide.lesson(":lessonId"),
    element: <GuideLessonPage />
  },
  {
    path: RoutesPaths.guide.qa,
    element: <GuideQAPage />
  },
  {
    path: RoutesPaths.guide.tourPreview.lead,
    element: <GuideTourPreviewLeadPage />
  },
  {
    path: RoutesPaths.guide.tourPreview.project,
    element: <GuideTourPreviewProjectPage section="overview" />
  },
  {
    path: RoutesPaths.guide.tourPreview.projectMilestones,
    element: <GuideTourPreviewProjectPage section="milestones" />
  },
  {
    path: RoutesPaths.guide.tourPreview.projectFinance,
    element: <GuideTourPreviewProjectPage section="finance" />
  },
  {
    path: RoutesPaths.guide.tourPreview.projectInvoices,
    element: <GuideTourPreviewProjectPage section="invoices" />
  },
  {
    path: RoutesPaths.guide.tourPreview.projectFiles,
    element: <GuideTourPreviewProjectPage section="files" />
  },
  {
    path: RoutesPaths.guide.tourPreview.projectActivity,
    element: <GuideTourPreviewProjectPage section="activity" />
  }
]
